import { useIntl } from 'react-intl';
import { useTrackedClickHandler } from 'src/analytics/trackedClickHandler';
import { useEventClickAppStore } from 'src/analytics/useEventClickAppStore';
import { MobileAppStoreData } from 'src/hooks/useMobileAppStores';
import { getExternalHref } from 'src/utils/getExternalHref';
import * as S from './styles';

export const VerticalStoreDownloadAndReviews = ({
  starsImageSrc,
  starsImageAlt,
  ratingsCount,
  hrefParams,
  DownloadButton,
  storeType,
}: MobileAppStoreData) => {
  const intl = useIntl();
  const href = getExternalHref(hrefParams);

  const eventClickAppStore = useEventClickAppStore(storeType);
  const trackedOnClick = useTrackedClickHandler(eventClickAppStore);

  return (
    <S.Wrapper>
      <S.DownloadWrapper>
        <DownloadButton />
      </S.DownloadWrapper>
      <S.Stars
        src={starsImageSrc}
        width={100}
        height={20}
        alt={intl.formatMessage(starsImageAlt)}
      />
      <S.Reviews href={href} onClick={trackedOnClick}>
        {intl.formatMessage(ratingsCount)}
      </S.Reviews>
    </S.Wrapper>
  );
};

VerticalStoreDownloadAndReviews.Container = S.Container;
